import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { H2, H4, BodySmall, Body } from '../ui/Typography';

export default function HowItWorks() {
  const steps = [
    {
      step: 1,
      title: "Buy RENT Tokens",
      points: [
        "Direct DEX trading",
        "Available on Raydium",
        "Simple swap process"
      ]
    },
    {
      step: 2,
      title: "Hold & Earn",
      points: [
        "Automatic monthly distributions",
        "Based on token amount",
        "No staking required"
      ]
    },
    {
      step: 3,
      title: "Track & Grow",
      points: [
        "Real-time portfolio updates",
        "Transparent performance",
        "Auto Compound your returns"
      ]
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 mb-16">
      <H2 className="text-primary mb-8 text-center">Simple Steps to Start Earning</H2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
        {steps.map((step, index) => (
          <div key={index} className="bg-gray-50 p-6 rounded-lg h-full">
            <div className="flex items-center justify-between mb-4">
              <BodySmall className="text-secondary font-bold">Step {step.step}</BodySmall>
            </div>
            <H4 className="text-gray-900 mb-4">{step.title}</H4>
            <ul className="space-y-2">
              {step.points.map((point, i) => (
                <li key={i} className="flex items-center">
                  <span className="w-2 h-2 bg-secondary rounded-full mr-2"></span>
                  <Body className="text-gray-600">{point}</Body>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-8 pt-8 border-t border-gray-100">
        <a
          href="https://raydium.io/swap/?inputMint=sol&outputMint=EPW6L3UrX8ArF4SVsGFNNNs2XccugnJGNNzXLeHUCNuz"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta w-full py-4 text-lg font-semibold flex items-center justify-center group"
          aria-label="Start investing in RENT tokens on Raydium decentralized exchange"
          data-tracking="cta-click"
          data-tracking-location="how-it-works"
          data-tracking-destination="raydium"
        >
          Start Your Journey - Buy RENT Now
          <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </div>
  );
}